import React, { useState, useEffect } from 'react';

const EditEmployeeForm = ({ employee, onSuccess, onCancel }) => {
  const [name, setName] = useState(employee.name || '');
  const [email, setEmail] = useState(employee.email || '');
  const [phone, setPhone] = useState(employee.phone || '');

  useEffect(() => {
    setName(employee.name || '');
    setEmail(employee.email || '');
    setPhone(employee.phone || '');
  }, [employee]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const updatedEmployee = {
      id: employee.id,
      name,
      email,
      phone,
    };
    onSuccess(updatedEmployee);
  };

  return (
    <form onSubmit={handleSubmit} className="edit-employee-form">
      <div>
        <label>Name:</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          autoFocus
        />
      </div>
      <div>
        <label>Email:</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      <div>
        <label>Phone:</label>
        <input
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          required
        />
      </div>
      <div className="form-buttons">
        <button type="submit">Update Employee</button>
        <button type="button" onClick={onCancel}>Cancel</button>
      </div>
    </form>
  );
};

export default EditEmployeeForm;
